import { ActionTypes } from "../constants";

export default function baskets(state = {}, action) {
  switch (action.type) {
    case ActionTypes.SET_BASKETS:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}